module.exports = __webpack_public_path__ + "static/media/loading-img.cd52b228.svg";